import { render, staticRenderFns } from "./FiltroRematricula.vue?vue&type=template&id=2795981d&scoped=true&"
import script from "./FiltroRematricula.vue?vue&type=script&lang=js&"
export * from "./FiltroRematricula.vue?vue&type=script&lang=js&"
import style0 from "./FiltroRematricula.vue?vue&type=style&index=0&id=2795981d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795981d",
  null
  
)

export default component.exports